module.exports = __webpack_public_path__ + "static/media/blue-user.7af0f596.svg";